export default __webpack_public_path__ + "static/media/Popup.d15e8bec.svg";